import {Component, OnInit} from '@angular/core';
import {ExcFileItem} from 'exc-upload-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';

@Component({
  selector: 'app-modal-upload-file',
  templateUrl: './modal-upload-file.component.html',
  styles: [
  ]
})
export class ModalUploadFileComponent extends  ExcTranslation implements OnInit {
  data: any;
  constructor(private modalService: ExgModalService) {
    super();
  }

  ngOnInit(): void {
  }
  uploadDocuments(files: ExcFileItem): void {
    /*this.attachmentSelectedFiles = this.attachmentSelectedFiles.concat(files);
    const formData = ExcFileItem.getFormData(this.attachmentSelectedFiles, {});
    if (formData) {
      formData.set('DataObject', JSON.stringify({FKID: this.Data.Company.dlrID}));
      const url = this.excRestServiceCore.computeUrl('DealerAttachmentC', {FKID: this.Data.Company.dlrID});
      this.excRestServiceCore.post(url, formData).subscribe((ret: any) => {
        if (ret) {
          this.getAttachmentListData();
        }
      });
    }
    this.attachmentSelectedFiles = [];*/
  }
}
